var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg041Folder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.001,410.537C-0.001,410.421,0.001,410.654,0.001,410.537L0.001,410.537z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.002,101.437c0,0.009-0.001,0.018-0.001,0.026C40.003,101.558,40.002,101.47,40.002,101.437z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.001,330.5c11.046,0,20-8.954,20-20v-167c0-16.027-6.241-31.095-17.574-42.427 c-11.332-11.33-26.396-17.569-42.416-17.569H452L233.962,83.5c-8.183-35.472-40.024-62.005-77.941-62.013l-76.02-0.024 c-44.112,0-80,35.888-80,80v309.074c0,44.112,35.888,80,80,80h352c44.112,0,80-35.888,80-80c0-11.046-8.954-20-20-20 c-11.046,0-20,8.954-20,20c0,22.056-17.944,40-40,40h-352c-22.056,0-40-17.944-40-39.999V101.463c0-0.049,0-0.043,0.001-0.026 c0.014-22.044,17.952-39.974,39.992-39.974l76.016,0.024c22.051,0.005,39.991,17.948,39.991,40v2.013c0,11.046,8.954,20,20,20 l236.003,0.004c5.341-0.001,10.362,2.078,14.14,5.855c3.777,3.776,5.857,8.799,5.857,14.141v167 C472.001,321.546,480.955,330.5,492.001,330.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg041Folder);
export default __webpack_public_path__ + "static/media/041-folder.3bc49be8748425f3dbe3907a5005ba11.svg";
export { ForwardRef as ReactComponent };